import React from "react";
import { Pie } from "ant-design-pro/lib/Charts";
import { Typography } from "antd";
import "ant-design-pro/dist/ant-design-pro.css";
import numeral from "numeral";
import { useTranslation } from "react-i18next";
const { Text } = Typography;

function PieClosedIncome({ payrolls, rents, other }) {
  const { t } = useTranslation();
  const salesPieData = [
    {
      x: t("balance.payrolls"),
      y: payrolls,
    },
    {
      x: t("balance.rents"),
      y: rents,
    },
    {
      x: t("form.others"),
      y: other,
    },
  ];
  return (
    <>
      <Pie
        title="Activos"
        colors={["#41D2DA", "#FFC069", "#FF7875"]}
        hasLegend={false}
        className="PieClosedIncome"
        data={salesPieData}
        valueFormat={(val) => <span>{numeral(val).format("0,0 $")}</span>}
        height={140}
      />
      <Text
        strong
        style={{
          marginRight: "10px",
          fontSize: "12px",
        }}
      >
        {t("balance.totalTitle")}
      </Text>
      <Text
        style={{
          color: "#02C3CD",
          fontSize: "12px",
        }}
      >
        {numeral(payrolls + rents + other).format("0,00 $")}
      </Text>
    </>
  );
}

export default PieClosedIncome;
